import React from 'react';
import './RadionicePage.scss';
import RadionicaData11 from '../../assets/json/radionice/workshop11.json';
import RadionicaData21 from '../../assets/json/radionice/workshop21.json';
import RadionicaData31 from '../../assets/json/radionice/workshop31.json';
import RadionicaData41 from '../../assets/json/radionice/workshop41.json';
import RadionicaData5 from '../../assets/json/radionice/workshop5.json';
import RadionicaData6 from '../../assets/json/radionice/workshop6.json';
import RadionicaComponent from '../RadionicaComponent/RadionicaComponent';
import RadionicaComponentVideo from '../RadionicaComponent/RadionicaComponentVideo';

const RadionicePage: React.FC = () => {
    return (
        <div className='radionice-page-container'>
            <h1 className='radionice-page-title document-main-title'>Radionice</h1>
           <RadionicaComponent data={RadionicaData11}></RadionicaComponent>
            <RadionicaComponent data={RadionicaData21}></RadionicaComponent>
            <RadionicaComponent data={RadionicaData31}></RadionicaComponent>
            <RadionicaComponent data={RadionicaData41}></RadionicaComponent>
            <RadionicaComponent data={RadionicaData5}></RadionicaComponent>
            <RadionicaComponentVideo data={RadionicaData6}></RadionicaComponentVideo>
        </div>
    )
}

export default RadionicePage;